import { fetchApi } from "./api";
import { API_ENDPOINTS } from "../config/api";
import type { SiteGateAdmin, SiteGateUpdate } from "../types/siteGate";

export async function getSiteGate(): Promise<SiteGateAdmin> {
  return fetchApi<SiteGateAdmin>(API_ENDPOINTS.siteGate);
}

export async function updateSiteGate(
  body: SiteGateUpdate,
): Promise<SiteGateAdmin> {
  return fetchApi<SiteGateAdmin>(API_ENDPOINTS.siteGateUpdate, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}
